import {
  MBANK_BRIDGE_ERROR_CODE,
  MBANK_BRIDGE_ERROR_MESSAGE,
  MBANK_BRIDGE_VERSION,
} from './constants'
import {
  MBankBridgeErrorResponse,
  MBankBridgeEventType,
  MBankBridgeResponse,
} from './types'

const getBridgeUnavailableResponse = (
  message: string,
): MBankBridgeErrorResponse => ({
  ok: false,
  error: {
    code: MBANK_BRIDGE_ERROR_CODE.UNAVAILABLE,
    message,
  },
})

type MBankBridgeLogSource = 'mtravel-webview' | 'mbank-bridge'

const isMBankBridgeEnabled = import.meta.env.VITE_USE_MBANK_BRIDGE !== 'false'

const logBridgeError = (
  type: MBankBridgeEventType,
  source: MBankBridgeLogSource,
  error: MBankBridgeErrorResponse['error'] | unknown,
) => {
  // if (import.meta.env.VITE_PROJECT_IS_DEV) {
  console.warn('[MTravel][MBankBridge] invoke failed', {
    source,
    type,
    error,
  })
  // }
}

const logBridgeInvoke = (type: MBankBridgeEventType) => {
  if (import.meta.env.VITE_PROJECT_IS_DEV) {
    console.info('[MTravel][MBankBridge] invoke started', {
      source: 'mtravel-webview',
      type,
    })
  }
}

export const callMBankBridge = async <TResult = unknown>(
  type: MBankBridgeEventType,
  payload?: Record<string, unknown>,
): Promise<MBankBridgeResponse<TResult>> => {
  if (!isMBankBridgeEnabled) {
    const response = getBridgeUnavailableResponse(
      MBANK_BRIDGE_ERROR_MESSAGE.DISABLED,
    )

    logBridgeError(type, 'mtravel-webview', response.error)

    return response
  }

  if (typeof window === 'undefined' || !window.MBankBridge) {
    const response = getBridgeUnavailableResponse(
      MBANK_BRIDGE_ERROR_MESSAGE.UNAVAILABLE,
    )

    logBridgeError(type, 'mtravel-webview', response.error)

    return response
  }

  if (
    window.MBankBridge.version !== MBANK_BRIDGE_VERSION ||
    typeof window.MBankBridge.invoke !== 'function'
  ) {
    const response = getBridgeUnavailableResponse(
      MBANK_BRIDGE_ERROR_MESSAGE.UNSUPPORTED_VERSION,
    )

    logBridgeError(type, 'mtravel-webview', response.error)

    return response
  }

  try {
    logBridgeInvoke(type)

    const response = await window.MBankBridge.invoke<TResult>(type, payload)

    if (!response.ok) {
      logBridgeError(type, 'mbank-bridge', response.error)
    }

    return response
  } catch (error) {
    logBridgeError(type, 'mtravel-webview', error)

    return getBridgeUnavailableResponse(
      MBANK_BRIDGE_ERROR_MESSAGE.INVOKE_FAILED,
    )
  }
}
